import { OperatorType } from 'src/types/operators/operators';

export const getUIOperatorSign = (sign: string): OperatorType => {
  if (sign === '=') return '=';
  if (sign === '!=') return '≠';
  if (sign === '<') return '<';
  if (sign === '>') return '>';
  if (sign === '<=') return '≤';
  if (sign === '>=') return '≥';
  throw new Error(`Unsupported operator sign: ${sign}`);
};
